module.exports = __webpack_public_path__ + "static/media/user-mobile-no.eb564976.svg";